import singleChoiceIcon from "../../../../Assets/singleChoiceIcon.svg";
import checkBoxResponse_icon from "../../../../Assets/checkBoxResponse_icon.svg";
import MultiResponse_icon from "../../../../Assets/MultiResponse_icon.svg";
import unselectedCheckBox_icon from "../../../../Assets/unselectedCheckBox_icon.svg";
import CheckBoxquestionIcon from "../../../../Assets/CheckBoxquestionIcon.svg";
import Website_Link from "../../../../Assets/Website_Link.svg";
import email_icon_Form from "../../../../Assets/email_icon_Form.svg";
import minusIcon_spinner from "../../../../Assets/minusIcon_spinner.svg";
import plusIcon_spinner from "../../../../Assets/plusIcon_spinner.svg";
import SignatureIconContainer from "../../../../Assets/SignatureIconContainer.svg";
import documentresponse_icon from "../../../../Assets/documentresponse_icon.svg";
import calendarIcon from "../../../../Assets/calendarIcon.svg";
import timeIconQuestion from "../../../../Assets/timeIconQuestion.svg";
import startquestion_icon from "../../../../Assets/startquestion_icon.svg";
import addrating_icon from "../../../../Assets/addrating_icon.svg";
import thumbsuprating_icon from "../../../../Assets/thumbsuprating_icon.svg";
import heartrating_icon from "../../../../Assets/heartrating_icon.svg";
import balloonrating_icon from "../../../../Assets/balloonrating_icon.svg";
import flagrating_icon from "../../../../Assets/flagrating_icon.svg";
import basketballrating_icon from "../../../../Assets/basketballrating_icon.svg";
import selected_startquestion_icon from "../../../../Assets/selected_startquestion_icon.svg";
import selected_addrating_icon from "../../../../Assets/selected_addrating_icon.svg";
import selected_thumbsuprating_icon from "../../../../Assets/selected_thumbsuprating_icon.svg";
import selected_heartrating_icon from "../../../../Assets/selected_heartrating_icon.svg";
import selected_balloonrating_icon from "../../../../Assets/selected_balloonrating_icon.svg";
import selected_flagrating_icon from "../../../../Assets/selected_flagrating_icon.svg";
import selected_basketballrating_icon from "../../../../Assets/selected_basketballrating_icon.svg";
import drop_down from "../../../../Assets/caret-drop-down.svg";
import responcechoice_icon from "../../../../Assets/responcechoice_icon.svg";
import axios from "axios";

const ShortAnswer = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="individualView_shortAnswer">{question.answer}</div>
    </div>
  );
};
const Location = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="address-container">
        {question.answer?.map(
          (address, i) =>
            address.type === "address" && (
              <div className="addresslineone" key={i}>
                <p style={{ color: "rgba(27, 36, 54, 1)", fontSize: "1rem" }}>
                  {address.value}
                </p>
              </div>
            )
        )}
        <div className="other-details-container">
          {question.answer?.map(
            (address, i) =>
              address.type === "text" && (
                <div className="addresslineone" key={i}>
                  <p style={{ color: "rgba(27, 36, 54, 1)", fontSize: "1rem" }}>
                    {address.value}
                  </p>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

const ParagraphAnswer = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="individualView_shortAnswer">{question.answer}</div>
    </div>
  );
};

const MultipleChoice = ({ question, index }) => {
  console.log(question.answer);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="questionView_OPtionContainer">
        {question.options.map((option, i) => (
          <div className="question_response_choice" key={i}>
            <img
              src={
                option.optionText === question.answer
                  ? checkBoxResponse_icon
                  : singleChoiceIcon
              }
              alt="singleChoiceIcon"
            />
            <div className="">{option.optionText}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const MultipleChoiceImage = ({ question, index }) => {
  const isAnyOptionTextLong = question.options.some(
    (option) => option.optionText.length > 35
  );
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div
        className="questionView_OPtionContainer"
        style={{
          flexDirection: isAnyOptionTextLong ? "column" : "row",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {question.options.map((option, i) => (
          <div
            className="question_response_choice"
            key={i}
            style={{
              fontSize: "0.875rem",
              display: "flex",
              flexDirection: isAnyOptionTextLong ? "row" : "column",
            }}
          >
            <img src={option.optionImage} alt="optionImage" />
            <img
              src={
                option.optionText === question.selectedOption
                  ? checkBoxResponse_icon
                  : singleChoiceIcon
              }
              alt="singleChoiceIcon"
            />
            <div className="">{option.optionText}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const CheckBox = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="questionView_OPtionContainer">
        {question.options.map((option, i) => (
          <div className="question_response_choice" key={i}>
            <img
              src={
                question.answer.includes(option.optionText)
                  ? MultiResponse_icon
                  : unselectedCheckBox_icon
              }
              alt="unselectedCheckBox_icon"
            />
            <div>{option.optionText}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const GridBox = ({ question, index }) => {
  console.log(question.answer[0]);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <table>
        <thead>
          <tr>
            <th></th>
            {question.column.map((column, colIndex) => (
              <th key={colIndex}>{column.columnText}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {question.row.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>{row.rowText}</td>
              {question.column.map((column, colIndex) => (
                <td key={colIndex}>
                  <div className="cell-content">
                    <img
                      src={
                        question.answer[rowIndex].value === column.columnText
                          ? checkBoxResponse_icon
                          : singleChoiceIcon
                      }
                      alt="singleChoiceIcon"
                    />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const CheckBoxGrid = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <table>
        <thead>
          <tr>
            <th></th>
            {question.column.map((column, colIndex) => (
              <th key={colIndex}>{column.columnText}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {question.row.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>{row.rowText}</td>
              {question.column.map((column, colIndex) => (
                <td key={colIndex}>
                  <div className="cell-content">
                    <img
                      src={
                        question.answer[rowIndex].values.includes(
                          column.columnText
                        )
                          ? MultiResponse_icon
                          : CheckBoxquestionIcon
                      }
                      alt="singleChoiceIcon"
                    />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const Phone = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div className="individual_Phone">
          <p>+91</p>
          {question.answer}
        </div>
      </div>
    </div>
  );
};

const Name = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="individual_nameAns_container">
        <div className="Name">
          {question.answer.firstName
            ? question.answer.firstName
            : "No Responses"}
        </div>
        <div className="Name">
          {question.answer.lastName ? question.answer.lastName : "No Responses"}
        </div>
      </div>
    </div>
  );
};

const Website = ({ question, index }) => {
  const formatUrl = (url) => {
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div className="Name" style={{ display: "flex", gap: "0.5rem" }}>
          <img src={Website_Link} alt="Website_Link" />
          {question.answer === "No Responses" ? (
            <p className="website_link">No Responses</p>
          ) : (
            <a
              href={formatUrl(question.answer)}
              target="_blank"
              rel="noopener noreferrer"
              className="website_link"
            >
              {question.answer}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const Email = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div className="individualView_email">
          <img src={email_icon_Form} alt="email_icon_Form" />
          <a
            href={`mailto:${question.answer.email}`}
            target="_blank"
            rel="noopener noreferrer"
            className="website_link"
          >
            {question.answer}
          </a>
        </div>
      </div>
    </div>
  );
};

const Number = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div className="individual_Phone">{question.answer}</div>
      </div>
    </div>
  );
};

const Spinner = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div
          className="Name"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "0.6rem",
            color: "#1b2436",
          }}
        >
          <img src={minusIcon_spinner} alt="minusIcon_spinner" />
          <p sty>{question.answer}</p>
          <img src={plusIcon_spinner} alt="plusIcon_spinner" />
        </div>
      </div>
    </div>
  );
};

const Signature = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div
        class="container"
        style={{
          width: `${question.boxWidth}px`,
          height: `${question.boxHeight}px`,
          minWidth: "45%",
          minHeight: "12.2rem",
          maxWidth: "90%",
          maxHeight: "22rem",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <p className="TextWPic">
          {question.answer === "No Responses" ? (
            <p>No Responses</p>
          ) : (
            <img src={question.answer} alt="question.answer" />
          )}
        </p>
        <div class="content">
          <img src={SignatureIconContainer} alt="SignatureIconContainer" />
          <p>Signature</p>
        </div>
      </div>
    </div>
  );
};

const Document = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="AnswerText">
          <p className="TextWPic">
            <img src={documentresponse_icon} alt="documentresponse_icon" />
            {question.answer}
          </p>
        </div>
      </div>
    </div>
  );
};

const VAFileUpload = ({ question, index }) => {
  const handleGetFile = async (fileKey) => {
    const Url = process.env.REACT_APP_API;
    console.log(fileKey);
    try {
      // Replace this with your actual API endpoint to get the signed URL
      const response = await axios.post(`${Url}/forms/retrieve`, { fileKey });

      if (response.data.success) {
        // Trigger the download
        const downloadUrl = response.data.url;
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileKey.split("/").pop(); // Set the download filename
        a.click();
      } else {
        alert("Failed to fetch the file URL.");
      }
    } catch (error) {
      console.error("Error getting signed URL", error);
    }
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div
          className="AnswerText"
          style={{ flexDirection: "column", gap: "1rem" }}
        >
          {question.answer.map((file, i) => (
            <p
              className="TextWPic"
              style={{ justifyContent: "start" }}
              key={i}
              onClick={() => handleGetFile(file[0].fileKey)}
            >
              <img src={documentresponse_icon} alt="documentresponse_icon" />
              {file[0].fileName}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
const FileUpload = ({ question, index }) => {
  const handleGetFile = async (fileKey) => {
    const Url = process.env.REACT_APP_API;
    console.log(fileKey);
    try {
      // Replace this with your actual API endpoint to get the signed URL
      const response = await axios.post(`${Url}/forms/retrieve`, { fileKey });

      console.log(response.data);
      if (response.data.success) {
        // Trigger the download
        const downloadUrl = response.data.url;
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileKey.split("/").pop(); // Set the download filename
        a.click();
      } else {
        alert("Failed to fetch the file URL.");
      }
    } catch (error) {
      console.error("Error getting signed URL", error);
    }
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div
          className="AnswerText"
          style={{ flexDirection: "column", gap: "1rem" }}
        >
          {question.answer.map((file, i) => (
            <p
              className="TextWPic"
              style={{ justifyContent: "start" }}
              key={i}
              onClick={() => handleGetFile(file[0].fileKey)}
            >
              <img src={documentresponse_icon} alt="documentresponse_icon" />
              {file[0].fileName}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
// Function to format date
const formatDate = (dateString, format) => {
  console.log(format);
  // Split the input date and format strings
  const dateParts = dateString?.split("-");
  const formatParts =
    format === "" || "undefined"
      ? "year-month-date".split("-")
      : format.split("-");
  // Map the parts to their respective names
  const day = dateParts[formatParts.indexOf("date")];
  const month = dateParts[formatParts.indexOf("month")];
  const year = dateParts[formatParts.indexOf("year")];

  return { day, month, year };
};

const Date = ({ question, index }) => {
  console.log(question.answer);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div
          className="calander"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            style={{
              width: "45%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <p className="individualView_DateText">
              {formatDate(question.answer, question.dateFormat).day}
            </p>
            <div>/</div>
            <p className="individualView_DateText">
              {formatDate(question.answer, question.dateFormat).month}
            </p>
            <div>/</div>
            <p className="individualView_DateText">
              {formatDate(question.answer, question.dateFormat).year}
            </p>
          </div>
          <img src={calendarIcon} alt="calendarIcon" className="calanderIcon" />
        </div>
      </div>
    </div>
  );
};

const formatTime = (timeString) => {
  const [hr, min, formate] = timeString?.split(":");
  return { hr, min, formate };
};
const DateAndTime = ({ question, index }) => {
  console.log(question.answer.date);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div
          className="calander"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            style={{
              width: "45%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <p className="individualView_DateText">
              {formatDate(question.answer.date).day}
            </p>
            <div>/</div>
            <p className="individualView_DateText">
              {formatDate(question.answer.date).month}
            </p>
            <div>/</div>
            <p className="individualView_DateText">
              {formatDate(question.answer.date).year}
            </p>
          </div>
          <img src={calendarIcon} alt="calendarIcon" className="calanderIcon" />
        </div>
        <div
          className="time"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            style={{
              width: "58%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <p className="individualView_DateText">
              {formatTime(question.answer.time).hr}
            </p>
            <div>/</div>
            <p className="individualView_DateText">
              {formatTime(question.answer.time).min}
            </p>
            <div>/</div>
            <p className="individualView_DateText">
              {formatTime(question.answer.time).formate}
            </p>
          </div>
          <img
            src={timeIconQuestion}
            alt="calendarIcon"
            className="calanderIcon"
          />
        </div>
      </div>
    </div>
  );
};

const images = {
  star: startquestion_icon,
  balloon: balloonrating_icon,
  addIcon: addrating_icon,
  thumbsup: thumbsuprating_icon,
  heart: heartrating_icon,
  flag: flagrating_icon,
  basketball: basketballrating_icon,
  // Add other types and their images here
};
const selectedImage = {
  star: selected_startquestion_icon,
  balloon: selected_balloonrating_icon,
  addIcon: selected_addrating_icon,
  thumbsup: selected_thumbsuprating_icon,
  heart: selected_heartrating_icon,
  flag: selected_flagrating_icon,
  basketball: selected_basketballrating_icon,
  // Add other types and their images here
};

const Ratings = ({ question, index }) => {
  const imageSrc = images[question.typeofdign];
  const selectedImageSrc = selectedImage[question.typeofdign];
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div className="ratingimg_container">
        {Array.from({ length: question.count }).map((_, i) => (
          <img
            key={i}
            src={i < question.answer.rating ? selectedImageSrc : imageSrc}
            alt={imageSrc}
          />
        ))}
      </div>
    </div>
  );
};

const Dropdown = ({ question, index }) => {
  console.log(question, index);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div className="Questionview_text">{question.questionText}</div>
      </div>
      <div className="nameAns_container">
        <div
          className="calander"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            style={{
              width: "45%",
              display: "flex",
              justifyContent: "flex-start",
              color: "#1b2436",
              fontFamily: "EuclidMedium",
            }}
          >
            <p>{question.answer}</p>
          </div>
          <img src={drop_down} alt="calendarIcon" className="calanderIcon" />
        </div>
      </div>
    </div>
  );
};

const LineScale = ({ question, index }) => {
  console.log(question);
  const divs = [];

  for (let i = question.minRange.value; i <= question.maxRange.value; i++) {
    divs.push(
      <div className="linescale_container">
        <div>{i}</div>
        <div>
          <img
            src={
              i === question.answer
                ? checkBoxResponse_icon
                : responcechoice_icon
            }
            alt="responcechoice_icon"
          />
        </div>
      </div>
    );
  }
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div className="Line_scale">
        <div>{question.maxRange.labelName}</div>
        {divs}
        <div>{question.minRange.labelName}</div>
      </div>
    </div>
  );
};

export {
  ShortAnswer,
  ParagraphAnswer,
  MultipleChoice,
  CheckBox,
  GridBox,
  CheckBoxGrid,
  Phone,
  Name,
  Website,
  Email,
  Number,
  Spinner,
  Signature,
  Document,
  Date,
  DateAndTime,
  Ratings,
  Dropdown,
  LineScale,
  MultipleChoiceImage,
  VAFileUpload,
  FileUpload,
  Location,
};
